import { Button, Col, Row } from "react-bootstrap";
import React from "react";
import { Link } from "react-router-dom";
import "./HomePage.css";
import { s3_url } from "common/constants";
import usePageTitle from "common/usePageTitle";

function HomePageLessons() {
  usePageTitle("Naslovna");

  return (
    <div>
      <h1>Lumen@home - online poduke</h1>
      <hr />

      <Row className="mb-5">
        <Col md={3} className="d-flex align-items-center">
          <img
            className="featurette-image img-fluid"
            src={`${s3_url}/img/poduke-v2/1.webp`}
            style={{ width: "100%" }}
            alt="Lumen@home"
            loading="lazy"
          />
        </Col>
        <Col md={6} className="d-flex align-items-center">
          <div>
            <h3>
              Tko je i što je <em>Lumen@home</em>?
            </h3>
            <p className="lead">
              <em>Lumen@home</em> je web platforma za izvođenje poduka iz raznih
              predmeta. Ideju o online podukama osmislila je vlasnica škole za
              poduke Lumen, Karmen Dasović. Karmen je magistra edukacije
              matematike i fizike koja već 30 godina uspješno vodi školu za
              poduke Lumen. Njena ljubav prema poučavanju nastavnih sadržaja
              odvela ju je u razne projekte, pa tako trenutno i u virtualni
              svijet. Osmislila je za vas najbolji način usvajanja gradiva iz
              raznih predmeta iz udobnosti vlastitog doma. Web platforma{" "}
              <em>Lumen@home</em> nudi vam izvođenje poduka iz raznih predmeta
              poput hrvatskog i drugih jezika, matematike, fizike, kemije,
              biologije.
            </p>
          </div>
        </Col>

        <Col md={3} className="d-flex align-items-center">
          <img
            className="featurette-image img-fluid mx-3"
            src={`${s3_url}/img/Prva_naslovna.webp`}
            style={{ width: "100%" }}
            alt="Lumen@home"
            loading="lazy"
          />
        </Col>
      </Row>

      <Row className="justify-content-center">
        <Col xs={12} sm={8} md={6} lg={4}>
          <Link to="/poduke/rezervacija">
            <Button className="w-100">Rezerviraj poduke!</Button>
          </Link>
        </Col>
      </Row>

      <Row className="my-5">
        <Col md={6} order={1} className="d-flex align-items-center">
          <img
            className="featurette-image img-fluid mx-auto"
            src={`${s3_url}/img/poduke-v2/lumen_laptop-8.webp`}
            style={{ width: "100%" }}
            alt="Lumen logo"
            loading="lazy"
          />
        </Col>
        <Col md={6} order={2} className="d-flex align-items-center">
          <div>
            <h3>
              Zašto odabrati poduke na <em>Lumen@home</em>?
            </h3>
            <p className="lead">
              Obzirom na užurbani tempo učenika, potrebe za druženjem sa svojim
              vršnjacima i izvannastavnim aktivnostima, odlučili smo uštediti
              vaše vrijeme i osmisliti online poduke koje možete pohađati gdje
              god bili, bez dolaska do naše škole. Zamislite da sjedite za
              svojim radnim stolom, a gradivo se usvaja! Upravo to vam nude
              poduke <em>Lumen@home</em>.
            </p>
          </div>
        </Col>
      </Row>

      <Row className="mb-5">
        <Col md={6} order={2} className="d-flex align-items-center">
          <div>
            <h3>
              Kako će se provoditi poduke na <em>Lumen@home</em>?
            </h3>
            <p className="lead">
              Ono što je sjajno kod naših online poduka jest da sami birate
              vrijeme kada ćete pohađati poduke! Osim što u kalendar sami
              upisujete termin pohađanja poduka koji vam odgovara i to u svako
              doba dana i svakim danom, uključujući i vikende, online poduke u
              Lumenu traju 60 minuta! Drugim riječima, nudimo vam 15 minuta više
              od uobičajenog trajanja poduka! Poduke se provode putem
              videopoziva, u realnom vremenu, tako da ćeš imati mogućnost
              razgovarati s nastavnikom i postavljati pitanja.
            </p>
          </div>
        </Col>
        <Col md={6} order={1} className="d-flex align-items-center">
          <img
            className="featurette-image img-fluid mx-auto"
            src={`${s3_url}/img/poduke-v2/lumen_laptop-6.webp`}
            style={{ width: "100%" }}
            alt="Lumen logo"
            loading="lazy"
          />
        </Col>
      </Row>

      <Row className="mb-5">
        <Col md={6} order={1} className="d-flex align-items-center">
          <img
            className="featurette-image img-fluid mx-auto"
            src={`${s3_url}/img/poduke-v2/lumen_laptop-3.webp`}
            style={{ width: "100%" }}
            alt="Lumen logo"
            loading="lazy"
          />
        </Col>
        <Col md={6} order={2} className="d-flex align-items-center">
          <div>
            <h3>Koliko će pristupnika imati online poduke?</h3>
            <p className="lead">
              Želimo održati kvalitetu našeg rada i u virtualnom okruženju pa će
              se poduke održavati individualno kako bismo se u potpunosti
              posvetili savladavanju/usavršavanju gradiva pojedinca. Ukoliko
              postoji više učenika iz istog razreda koji žele poduke iz istog
              dijela gradiva, Lumen vam daje i tu mogućnost, uz naznaku prilikom
              prijave i dodatne pogodnosti u vidu popusta na količinu!
            </p>
            <h3>
              Tko će voditi poduke na <em>Lumen@home</em>?
            </h3>
            <p className="lead">
              Poduke vode naši dugogodišnji suradnici s višegodišnjim iskustvom
              rada u školi, kao i vođenju poduke za ispite državne mature i
              izvođenje poduka. Upoznati naše nastavnike možeš na izbornoj
              traci, gumb nastavnici.
            </p>
            <h3>
              Kako se prijaviti na poduke na <em>Lumen@home</em>?
            </h3>
            <p className="lead">
              Prijava je vrlo jednostavna. Prvo morate ispuniti prijavnicu za
              poduke koja se nalazi na crvenim gumbima na naslovnoj stranici ili
              na izbornoj traci platforme Prijava Poduka. Ukoliko imaš dodatnih
              pitanja možeš nam se obratiti na{" "}
              <a href="mailto:info@lumenpoduke.com">info@lumenpoduke.com</a> ili{" "}
              <a href="tel:+38598257119">098 257 119</a>.
            </p>
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default HomePageLessons;
